import React, { Component } from 'react';
import Table3_1_1 from "./3-1-1";
import Table3_1_2 from "./3-1-2";
// import Table3_1_3 from "./3-1-3";
import Table3_1_4 from "./3-1-4";
import Table3_1_5 from "./3-1-5";
// import Table3_1_6 from "./3-1-6";
import Table3_1_7 from "./3-1-7";

export class index extends Component {
  render() {
    return (
      <div>
            <Table3_1_1 {...this.props} />
            <Table3_1_2 {...this.props} />
            <Table3_1_4 {...this.props} />
            <Table3_1_5 {...this.props} />
            <Table3_1_7 {...this.props} />
      </div>
    )
  }
};

export default index;



// WEBPACK FOOTER //
// ./src/components/table/3.0/3-1/index.js